import toast from 'react-hot-toast';

type MaterialToastOptions = {
  html: string;
  displayLength?: number;
  classes?: string;
};

export function showToast(options: MaterialToastOptions | string) {
  if (typeof options === 'string') {
    return toast(options);
  }

  const { html, displayLength } = options;
  return toast(html, displayLength ? { duration: displayLength } : undefined);
}
